/**
 * paymentMethods — Única fuente de verdad para los métodos de pago de un contrato.
 *
 * Un contrato puede tener más de un método de pago (`payment_methods`). El campo
 * `payment_method_type` se conserva por compatibilidad: el backend lo mantiene
 * sincronizado con el primer método de la lista, y los contratos creados antes
 * de este cambio solo cuentan con él.
 */

import type { PaymentMethodType, contractData } from "../types/uploadContract";

export const PAYMENT_METHOD_TYPES: PaymentMethodType[] = [
  "Transferencia",
  "Deposito",
  "Efectivo",
];

/** Métodos de pago de un contrato, con respaldo al campo antiguo. */
export const getPaymentMethods = (
  contract?: Partial<contractData> | null
): PaymentMethodType[] => {
  if (!contract) return [];
  if (contract.payment_methods?.length) return contract.payment_methods;
  return contract.payment_method_type ? [contract.payment_method_type] : [];
};

/** Representación en texto, para plantillas y PDFs. */
export const formatPaymentMethods = (
  contract?: Partial<contractData> | null
): string => getPaymentMethods(contract).join(", ");
